import React from 'react';

const MenuIcon: React.FC = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.83382 10.4993C5.83382 9.57887 5.08763 8.83268 4.16715 8.83268C3.24668 8.83268 2.50049 9.57887 2.50049 10.4993C2.50049 11.4198 3.24668 12.166 4.16715 12.166C5.08763 12.166 5.83382 11.4198 5.83382 10.4993Z"
      fill="#464255"
    />
    <path
      d="M11.6658 10.4993C11.6658 9.57887 10.9197 8.83268 9.99918 8.83268C9.07871 8.83268 8.33252 9.57887 8.33252 10.4993C8.33252 11.4198 9.07871 12.166 9.99918 12.166C10.9197 12.166 11.6658 11.4198 11.6658 10.4993Z"
      fill="#464255"
    />
    <path
      d="M17.5018 10.4993C17.5018 9.57887 16.7556 8.83268 15.8351 8.83268C14.9146 8.83268 14.1685 9.57887 14.1685 10.4993C14.1685 11.4198 14.9146 12.166 15.8351 12.166C16.7556 12.166 17.5018 11.4198 17.5018 10.4993Z"
      fill="#464255"
    />
  </svg>
);

export default MenuIcon;
